import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Fun, Pair, mk_pair, Options, mk_widget } from "../widget";

export interface Branch<i,o> {
  condition:Fun<i,boolean>
  widget:IOWidget<i,o>
}

export interface ChoiceProps<i,o> {
  input:i
  branches:Branch<i,o>[]
  on_done:(output:o) => void
}
export interface ChoiceState<i,o> {
}
export class Choice<i,o> extends React.Component<ChoiceProps<i,o>, ChoiceState<i,o>> {
  constructor(props:ChoiceProps<i,o>, context:any) {
    super(props, context)

    this.state = { value1:null, value2:null }
  }

  render() {
    return this.props.branches.map(branch =>
      branch.condition(this.props.input) ? branch.widget(this.props.input).run(output => this.props.on_done(output))
      : null)
  }
}

export let choice = function<i,o>(branches:Branch<i,o>[]) :
  IOWidget<i,o> {
  return (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<ChoiceProps<i,o>>(Choice, { branches, input, on_done })
  })
}
